import React from "react";
import { DisplayBox, Loading } from "../../components";
import { AccountInterface, ApiHelper, ChargeInterface, DateHelper, InvoiceInterface, UserHelper } from "../../helpers";

interface Props {
  invoice: InvoiceInterface,
  onClose: () => void
}

export const Charges: React.FC<Props> = props => {

  const [charges, setCharges] = React.useState<ChargeInterface[]>(null);


  const init = () => {
    if (props.invoice?.id > 0) ApiHelper.get<ChargeInterface[]>("/charges/invoice/" + props.invoice.id).then((data) => setCharges(data || []));
  }

  React.useEffect(init, [props.invoice?.id])


  const getTable = () => {
    if (charges === null) return <Loading />
    else {
      if (charges.length === 0) return <p>There are no charges</p>
      else {
        const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

        const rows: React.ReactElement[] = [];
        charges.forEach(c => {
          rows.push(<tr>
            <td>{c.description}</td>
            <td>{DateHelper.prettyDate(DateHelper.convertToDate(c.startDate))}</td>
            <td>{DateHelper.prettyDate(DateHelper.convertToDate(c.endDate))}</td>
            <td>{formatter.format(c.amount)}</td>
          </tr>)
        });
        return (<table className="table table-sm table-striped">
          <thead>
            <tr><th>Description</th><th>Start</th><th>End</th><th>Amount</th></tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>)
      }
    }
  }

  const handlePrint = async (e: React.MouseEvent) => {
    e.preventDefault();
    const frame: any = document.getElementById("printFrame");
    const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    const account: AccountInterface = await ApiHelper.get("/accounts/" + UserHelper.currentDepartment.accountId);
    const invoiceDate = DateHelper.convertToDate(props.invoice.endDate);
    invoiceDate.setDate(invoiceDate.getDate() + 1);
    const dueDate = DateHelper.convertToDate(props.invoice.endDate);
    dueDate.setDate(dueDate.getDate() + 6);

    const chargeList: string[] = [];
    charges.forEach(c => {
      chargeList.push("<tr><td>" + c.description + "</td><td>1</td><td>" + formatter.format(c.amount) + "</td><td>" + formatter.format(c.amount) + "</td></tr>");
    });

    let displayAddress = "";
    if (account.address1) displayAddress += account.address1;
    if (account.address2) displayAddress += ", " + account.address2;
    if (account.city) displayAddress += "<br/>" + account.city + ", " + account.state + " " + account.zip;
    if (account.country) displayAddress += " - " + account.country;


    frame.contentWindow.populate(
      props.invoice.id, account.name, DateHelper.getShortDate(invoiceDate), DateHelper.getShortDate(dueDate),
      (props.invoice.status === "Paid") ? "$0.00" : formatter.format(props.invoice.amount)
      , chargeList.join(""),
      formatter.format(props.invoice.amount), formatter.format(props.invoice.amount),
      (props.invoice.status === "Paid") ? formatter.format(props.invoice.amount) : "$0.00",
      displayAddress
    );
  }

  const getHeaderButtons = () => {
    return <>
      <a href="about:blank" onClick={handlePrint}> <i className="fas fa-print text-primary"></i></a>
      <a href="about:blank" onClick={(e) => { e.preventDefault(); props.onClose() }}> <i className="fas fa-window-close text-danger"></i></a>
    </>
  }

  return (
    <>
      <DisplayBox headerText={DateHelper.formatDateTime(DateHelper.convertToDate(props.invoice.startDate), "MMMM yyyy") + " Invoice Charges"} headerIcon="fas fa-credit-card" editContent={getHeaderButtons()} >
        {getTable()}
      </DisplayBox>
      <iframe id="printFrame" src="/invoice.html" style={{ width: 1, height: 1, opacity: 0.01 }} title="Print" ></iframe>
    </>
  );
};